import { Dialog } from '@headlessui/react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

import XIcon from '../../assets/images/icons/x-close-filter.svg?react'
import { useNavigateBillingModal } from '../../utils/context/modal/use-navigate-billing-modal'
import useIntercomInternal from '../../utils/hooks/use-intercom-internal'

function NavigateBillingModal() {
  const { isOpen, close, feature } = useNavigateBillingModal()

  const { trackFeatureDisabledInternal } = useIntercomInternal()

  useEffect(() => {
    if (isOpen && feature) {
      trackFeatureDisabledInternal(feature)
    }
  }, [isOpen, feature])

  return (
    <>
      <Dialog open={isOpen} onClose={() => close()} className="relative z-50 ">
        <div
          className="fixed inset-0 flex items-center justify-center overflow-auto "
          style={{
            background: 'rgba(41, 41, 41, 0.7)',
            backdropFilter: 'blur(8px)',
          }}
        >
          <Dialog.Panel className="relative border rounded-2xl shadow-2xl bg-white-100 lg:w-2/5 text-center">
            <div className="flex flex-col p-6 space-y-6 relative">
              <div className="absolute top-6 right-6">
                <button type="button" onClick={() => close()}>
                  <XIcon />
                </button>
              </div>
              <div className="flex flex-col space-y-4">
                <p className="text-lg font-semibold">
                  Let's Upgrade Your Prisync Account!
                </p>
                <p className="">
                  This feature is not enabled in your current Prisync Plan. In
                  order to start using this feature, we'll need you to upgrade
                  your Prisync Account.
                </p>
              </div>
              <Link to={'/billing/plans'} onClick={() => close()}>
                <button className="py-2 px-3 font-medium text-base text-white-100 border border-solid border-primary-600 bg-primary-600 rounded-lg shadow-sm active:bg-primary-700">
                  Upgrade Now{' '}
                </button>
              </Link>
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  )
}

export default NavigateBillingModal
